export default "/static/webpack/media/mail.04d23b62.svg";